import React, { useState } from 'react';
import { apiCall, getAdminUser } from '../services/apiService';

const ChangePassword = () => {
  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [countdown, setCountdown] = useState(0);
  const [userEmail, setUserEmail] = useState('');

  // 获取用户邮箱
  React.useEffect(() => {
    const user = getAdminUser();
    if (user && user.email) {
      setUserEmail(user.email);
    }
  }, []);

  // 倒计时逻辑
  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  // 发送验证码
  const handleSendCode = async () => {
    setIsSendingCode(true);
    setMessage({ type: '', text: '' });

    try {
      const result = await apiCall('/admin/send-password-reset-code', {
        method: 'POST',
      });

      if (result.success) {
        setMessage({
          type: 'success',
          text: `验证码已发送到 ${result.email}`,
        });
        setCountdown(60); // 60秒倒计时
        setTimeout(() => setMessage({ type: '', text: '' }), 5000);
      } else {
        setMessage({
          type: 'error',
          text: result.message || '发送验证码失败',
        });
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: '网络错误，请稍后重试',
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } finally {
      setIsSendingCode(false);
    }
  };

  const validatePassword = (password) => {
    if (password.length < 8) {
      return '密码长度至少8个字符';
    }
    if (!/[A-Z]/.test(password)) {
      return '密码必须包含至少一个大写字母';
    }
    if (!/[0-9]/.test(password)) {
      return '密码必须包含至少一个数字';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 验证输入
    if (!verificationCode || !newPassword || !confirmPassword) {
      setMessage({
        type: 'error',
        text: '所有字段都是必填的',
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    // 验证验证码格式（6位数字）
    if (!/^\d{6}$/.test(verificationCode)) {
      setMessage({
        type: 'error',
        text: '请输入6位数字验证码',
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    // 验证新密码强度
    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setMessage({
        type: 'error',
        text: passwordError,
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    // 检查两次密码是否一致
    if (newPassword !== confirmPassword) {
      setMessage({
        type: 'error',
        text: '新密码和确认密码不一致',
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    setIsLoading(true);
    try {
      const result = await apiCall('/admin/reset-password', {
        method: 'POST',
        body: JSON.stringify({
          code: verificationCode,
          newPassword,
        }),
      });

      if (result.success) {
        setMessage({
          type: 'success',
          text: '密码修改成功',
        });
        // 清空表单
        setVerificationCode('');
        setNewPassword('');
        setConfirmPassword('');
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      } else {
        setMessage({
          type: 'error',
          text: result.message || '修改密码失败',
        });
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: '网络错误，请稍后重试',
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-[#1a1d17] border border-[#2a2d27] rounded-lg p-8">
      <h2 className="text-white text-xl font-semibold mb-6">修改密码</h2>
      <div className="max-w-md">
        {/* 消息提示 */}
        {message.text && (
          <div
            className={`mb-6 p-4 rounded-lg border flex items-center gap-3 ${
              message.type === 'success'
                ? 'bg-green-500/20 border-green-500/50 text-green-300'
                : 'bg-red-500/20 border-red-500/50 text-red-300'
            }`}
          >
            {message.type === 'success' ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-64-64a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-56h16a8,8,0,0,0,8-8V88a8,8,0,0,0-16,0v56A8,8,0,0,0,120,160Zm12-36a12,12,0,1,1-12-12A12,12,0,0,1,132,124Z"></path>
              </svg>
            )}
            <span className="text-sm">{message.text}</span>
          </div>
        )}

        {/* 修改密码表单 */}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* 隐藏的邮箱字段 - 用于浏览器自动填充凭证 */}
          <input
            type="email"
            name="email"
            value={getAdminUser()?.email || ''}
            style={{ display: 'none' }}
            readOnly
          />

          {/* 邮箱显示 */}
          <div>
            <label className="block text-sm font-medium text-white mb-2">
              邮箱地址
            </label>
            <input
              type="email"
              value={userEmail}
              className="w-full px-4 py-3 rounded-lg bg-[#262a22] border-2 border-[#4b5445] text-gray-400 cursor-not-allowed"
              disabled
              readOnly
            />
            <p className="mt-1 text-xs text-gray-500">验证码将发送到此邮箱</p>
          </div>

          {/* 验证码 */}
          <div>
            <label className="block text-sm font-medium text-white mb-2">
              验证码
            </label>
            <div className="flex gap-3">
              <input
                type="text"
                value={verificationCode}
                onChange={(e) =>
                  setVerificationCode(
                    e.target.value.replace(/\D/g, '').slice(0, 6)
                  )
                }
                placeholder="请输入6位数字验证码"
                className="flex-1 px-4 py-3 rounded-lg bg-[#262a22] border-2 border-[#4b5445] text-white placeholder-gray-500 focus:outline-none focus:border-[#5a6f4a] transition-colors"
                disabled={isLoading}
                maxLength={6}
                autoComplete="one-time-code"
              />
              <button
                type="button"
                onClick={handleSendCode}
                disabled={isSendingCode || countdown > 0 || isLoading}
                className="px-6 py-3 bg-[#4a5f3a] hover:bg-[#5a7f4a] disabled:bg-[#4a5f3a]/50 disabled:cursor-not-allowed text-white rounded-lg font-medium transition-colors whitespace-nowrap"
              >
                {isSendingCode ? (
                  <span className="flex items-center gap-2">
                    <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                    发送中...
                  </span>
                ) : countdown > 0 ? (
                  `${countdown}秒`
                ) : (
                  '获取验证码'
                )}
              </button>
            </div>
            <p className="mt-1 text-xs text-gray-500">验证码将在10分钟内有效</p>
          </div>

          {/* 新密码 */}
          <div>
            <label className="block text-sm font-medium text-white mb-2">
              新密码
            </label>
            <div className="relative">
              <input
                type={showNewPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="请输入新密码"
                className="w-full px-4 py-3 pr-12 rounded-lg bg-[#262a22] border-2 border-[#4b5445] text-white placeholder-gray-500 focus:outline-none focus:border-[#5a6f4a] transition-colors"
                disabled={isLoading}
                autoComplete="new-password"
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors disabled:opacity-50"
                disabled={isLoading}
              >
                {showNewPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                  >
                    <path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C190.29,52.41,153.53,37,128,37s-62.29,15.41-91.66,49.35C17.51,105.18,9.05,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C65.71,203.59,102.47,219,128,219s62.29-15.41,91.66-49.35c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,191a63,63,0,1,1,63-63A63.07,63.07,0,0,1,128,191Zm0-112a49,49,0,1,0,49,49A49.06,49.06,0,0,0,128,79Z"></path>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                  >
                    <path d="M53.92,34.62A8,8,0,1,0,42.08,45.46l44,50.91a88.4,88.4,0,0,0-20.08,29.54H40a8,8,0,0,0,0,16h27.35A127.6,127.6,0,0,1,128,40c23.12,0,45.62,7.2,66.35,20.46l23.59,27.31a8,8,0,0,0,6.14,3,7.86,7.86,0,0,0,5.11-1.71,8,8,0,0,0-5.11-14.12L196.56,48a111.33,111.33,0,0,0-28.92-10.31l12.67-14.64a8,8,0,1,0-12.3-10.38Zm50,116.13A47.89,47.89,0,0,1,128,145a48,48,0,0,1,32,84,48.4,48.4,0,0,1-8.35.72A47.88,47.88,0,0,1,103.92,150.75ZM216,128a8,8,0,0,1-8,8H180.65a127.6,127.6,0,0,1-115.35,64H40a8,8,0,0,1,0-16h27.35A111.45,111.45,0,0,0,128,179.9,112,112,0,0,0,180.65,124H208A8,8,0,0,1,216,128Z"></path>
                  </svg>
                )}
              </button>
            </div>
            <div className="mt-2 text-xs text-gray-400">
              <p>密码需要符合以下要求:</p>
              <p>• 至少8个字符</p>
              <p>• 至少包含一个大写字母（A-Z）</p>
              <p>• 至少包含一个数字（0-9）</p>
            </div>
          </div>

          {/* 确认新密码 */}
          <div>
            <label className="block text-sm font-medium text-white mb-2">
              确认新密码
            </label>
            <div className="relative">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="请再次输入新密码"
                className="w-full px-4 py-3 pr-12 rounded-lg bg-[#262a22] border-2 border-[#4b5445] text-white placeholder-gray-500 focus:outline-none focus:border-[#5a6f4a] transition-colors"
                disabled={isLoading}
                autoComplete="new-password"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors disabled:opacity-50"
                disabled={isLoading}
              >
                {showConfirmPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                  >
                    <path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C190.29,52.41,153.53,37,128,37s-62.29,15.41-91.66,49.35C17.51,105.18,9.05,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C65.71,203.59,102.47,219,128,219s62.29-15.41,91.66-49.35c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,191a63,63,0,1,1,63-63A63.07,63.07,0,0,1,128,191Zm0-112a49,49,0,1,0,49,49A49.06,49.06,0,0,0,128,79Z"></path>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                  >
                    <path d="M53.92,34.62A8,8,0,1,0,42.08,45.46l44,50.91a88.4,88.4,0,0,0-20.08,29.54H40a8,8,0,0,0,0,16h27.35A127.6,127.6,0,0,1,128,40c23.12,0,45.62,7.2,66.35,20.46l23.59,27.31a8,8,0,0,0,6.14,3,7.86,7.86,0,0,0,5.11-1.71,8,8,0,0,0-5.11-14.12L196.56,48a111.33,111.33,0,0,0-28.92-10.31l12.67-14.64a8,8,0,1,0-12.3-10.38Zm50,116.13A47.89,47.89,0,0,1,128,145a48,48,0,0,1,32,84,48.4,48.4,0,0,1-8.35.72A47.88,47.88,0,0,1,103.92,150.75ZM216,128a8,8,0,0,1-8,8H180.65a127.6,127.6,0,0,1-115.35,64H40a8,8,0,0,1,0-16h27.35A111.45,111.45,0,0,0,128,179.9,112,112,0,0,0,180.65,124H208A8,8,0,0,1,216,128Z"></path>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* 提交按钮 */}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[#4a5f3a] hover:bg-[#5a7f4a] disabled:bg-[#4a5f3a]/50 disabled:cursor-not-allowed text-white px-6 py-3 rounded-lg font-medium transition-colors mt-6"
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                处理中...
              </span>
            ) : (
              '修改密码'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
